import React from 'react'
import { ContactImgWrap, ContactContainer, ContactH2, ContactP, ContactSocial, ContactArea, ContactButton } from './ContactElements'
import insta from '../../images/insta.png'
import twi from '../../images/twitter.png'
import dc from '../../images/dc.png'
import './contact.css'
import { useState } from 'react'
import EmailData from '../../dbApi'

const Contact = () => {
    let initialEmailState = "";

    const [email, setEmail] = useState(initialEmailState);

    const handleInputChange = event => {
        setEmail(event.target.value);
    }

    const saveEmail = () => {

        if(email.indexOf('@') < 0){
            alert("Please enter a real email adress.")
            setEmail("")
        }else{

        var data = {
            "email": email
        }

        EmailData.createEmail(data).then(response => {
            console.log(response.data)
            alert("We've received your email!")
            setEmail("")
        })}
    }

    return (
        <ContactContainer id="Contact">
            <ContactH2>Join our community!</ContactH2>
            
            <ContactSocial>
            <a target="_blank" href="https://www.instagram.com/the_dnms_nft/"><img src={insta} className="contacts" alt="insta"/></a>
            <a target="_blank" href="https://twitter.com/The_DNMS_NFT"><img src={twi} className="contacts" alt="twitter"/></a>
            <a target="_blank" href="https://discord.gg/wQaH48BfdK"><img src={dc} className="contacts" alt="dc"/></a>
            </ContactSocial>

            <ContactP>Subscribe to join presale and get first-hand info!</ContactP>
            

            <ContactArea 
                type="text"
                id = "text"
                value={email}
                onChange={handleInputChange}
                name="text"
                placeholder="Tell us your email?"
            />
            <ContactImgWrap>
            
            </ContactImgWrap>
            <ContactButton onClick={saveEmail} >Subscribe</ContactButton>
        </ContactContainer>
    )
}

export default Contact
